import React from 'react';
import Button from '../../components/Button';
import PageHeader from '../../components/PageHeader';
import PageSeo from '../../components/PageSeo';
import TheSecondaryPage from '../../components/TheSecondaryPage';

function MarketplacePage() {
  const description = `See all Shitty NFTs that are for sale on the secondary market.`;

  return (
    <>
      <PageSeo title={`Shitty Marketplace`} description={description} />

      <div className='pb-12 md:pb-48 bg-bg'>
        <PageHeader
          fullWidth
          heading={'Shitty Marketplace'}
          description={description}
          rightAction={
            <div className='flex md:items-center flex-col md:flex-row gap-3 w-full md:w-auto'>
              <Button link theme='outline' href='/profile?tab=listings' className='flex items-center gap-3 text-white w-full md:w-auto'>
                <span className='md:text-lg font-bold'>View My Listings</span>
              </Button>
            </div>
          }
        />
        <div className='px-4 lg:mx-auto'>
          <TheSecondaryPage />
        </div>
      </div>
    </>
  );
}

export default MarketplacePage;
